import React, { Component } from "react";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";

const BANK_STATUS = {
    0: { label: "Pending",  color: "#d46b08", bg: "#fff7e6" },
    1: { label: "Verified", color: "#1a7a42", bg: "#e6f7ee" },
    2: { label: "Rejected", color: "#c0392b", bg: "#fff0f0" },
};

class UserBankDetails extends Component {
    constructor(props) {
        super(props);
        this.state = { bankDetails: [] };
    }

    componentDidMount() {
        this.fetchBankDetails();
    }

    fetchBankDetails = async () => {
        store.dispatch(setLoader(true));
        try {
            let resp = await ApiEndpoints.UserProfile.fetchBankDetails({ user_id: this.props.user_id });
            this.setState({ bankDetails: resp.data.data });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    render() {
        let { bankDetails } = this.state;

        if (!bankDetails.length) {
            return <div style={S.empty}>No bank details added.</div>;
        }

        return (
            <div>
                {bankDetails.map((bank, i) => {
                    const status = BANK_STATUS[bank.status] || BANK_STATUS[0];
                    const maskedAcc = bank.account_no
                        ? "****" + bank.account_no.slice(-4)
                        : "—";
                    const isDeleted = bank.is_active === "0" || bank.is_active === 0;

                    return (
                        <div key={i} style={{ ...S.card, opacity: isDeleted ? 0.7 : 1 }}>
                            {/* Card header */}
                            <div style={S.cardHeader}>
                                <div>
                                    <div style={S.bankName}>{bank.bank_name || "—"}</div>
                                    <div style={S.ifsc}>{bank.ifsc_code || "—"}</div>
                                </div>
                                <div style={S.badgeRow}>
                                    <span style={{ ...S.statusBadge, background: status.bg, color: status.color }}>
                                        {bank.status === 1 ? "✓ " : bank.status === 2 ? "✗ " : "● "}{status.label}
                                    </span>
                                    {!!bank.is_default && (
                                        <span style={S.defaultBadge}>Default</span>
                                    )}
                                    {isDeleted && (
                                        <span style={S.deletedBadge}>Deleted</span>
                                    )}
                                </div>
                            </div>

                            <div style={S.divider} />

                            {/* Card body */}
                            <div style={S.cardBody}>
                                <div style={S.fieldGroup}>
                                    <span style={S.fieldLabel}>Account Number</span>
                                    <span style={S.fieldValue}>{maskedAcc}</span>
                                </div>
                                <div style={S.fieldGroup}>
                                    <span style={S.fieldLabel}>Account Holder</span>
                                    <span style={{
                                        ...S.fieldValue,
                                        color: bank.status === 2 ? "#c0392b" : "#1a1a1a",
                                        fontStyle: bank.status === 2 ? "italic" : "normal",
                                    }}>
                                        {bank.account_name || "—"}
                                    </span>
                                </div>
                                <div style={S.fieldGroup}>
                                    <span style={S.fieldLabel}>Created</span>
                                    <span style={S.fieldValueMeta}>
                                        {moment(bank.created_on).utcOffset("+05:30").format("Do MMM'YY HH:mm")}
                                    </span>
                                </div>
                                <div style={S.fieldGroup}>
                                    <span style={S.fieldLabel}>Updated</span>
                                    <span style={S.fieldValueMeta}>
                                        {moment(bank.modified_on).utcOffset("+05:30").format("Do MMM'YY HH:mm")}
                                    </span>
                                </div>
                                {bank.status_comment && (
                                    <div style={{ ...S.fieldGroup, gridColumn: "1 / -1" }}>
                                        <span style={S.fieldLabel}>Rejection Reason</span>
                                        <span style={{ ...S.fieldValueMeta, color: "#c0392b" }}>{bank.status_comment}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

const S = {
    card: {
        border: "1px solid #e8e8e8",
        borderRadius: 12,
        background: "#fff",
        marginBottom: 12,
        overflow: "hidden",
    },
    cardHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 18px",
        flexWrap: "wrap",
        gap: 8,
    },
    bankName: {
        fontSize: 15,
        fontWeight: 700,
        color: "#1a1a1a",
    },
    ifsc: {
        fontSize: 12,
        color: "#888",
        marginTop: 2,
    },
    badgeRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        justifyContent: "flex-end",
    },
    statusBadge: {
        padding: "3px 12px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
    },
    defaultBadge: {
        background: "#e8e8e8",
        color: "#555",
        borderRadius: 999,
        padding: "3px 10px",
        fontSize: 11,
        fontWeight: 600,
    },
    deletedBadge: {
        background: "#c0392b",
        color: "#fff",
        borderRadius: 999,
        padding: "3px 10px",
        fontSize: 11,
        fontWeight: 600,
    },
    divider: { borderTop: "1px solid #f0f0f0" },
    cardBody: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 0,
        padding: "4px 18px 14px",
    },
    fieldGroup: {
        padding: "8px 0",
        borderBottom: "1px solid #f8f8f8",
    },
    fieldLabel: {
        display: "block",
        fontSize: 11,
        color: "#aaa",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.3px",
        marginBottom: 3,
    },
    fieldValue: {
        fontSize: 14,
        color: "#1a1a1a",
        fontWeight: 500,
    },
    fieldValueMeta: {
        fontSize: 12,
        color: "#666",
    },
    empty: {
        padding: "40px 20px",
        textAlign: "center",
        color: "#aaa",
        fontSize: 14,
        fontStyle: "italic",
    },
};

export default UserBankDetails;
